import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { VaaService } from "src/app/services/vaa.service";
import { OndernemingService } from "src/app/services/onderneming.service";
import { ActivatedRoute, Router } from '@angular/router';
import { Vaa } from '../../models/Vaa';
import { Onderneming } from '../../models/Onderneming';
import { DataService } from "src/app/services/data.service";
import { Subscription, Subject, throwError } from 'rxjs';
import { FormBuilder, Validators } from '@angular/forms';
import { IFormBuilder, IFormGroup } from '@rxweb/types';
import { takeUntil, flatMap, take, mergeMap, switchMap, catchError } from 'rxjs/operators';
//import { Console } from 'console';
interface VaaForm {
  waardeWagen: number | null;
  co2Emissie: number | null;
  brandstofType: string | null;
  datumInschrijving: Date | null;
}

@Component({
  selector: 'app-vaa',
  templateUrl: './vaa.component.html',
  styleUrls: ['./vaa.component.scss']
})
export class VaaComponent implements OnInit, OnDestroy {
  //Boolean voor het vertonen van de uitkomst
  calculate = false;

  //Uitkomst
  result: number = null;

  
  //statische gegevens van de formule
  basiscoefBenzine2024: number = 70;

  basiscoefDiesel2024: number = 58;
  //Indien co2emissie onbekend is van diesel, dan is dit de standaard waarde
  standaardWaardeDieselUitstoot: number = 165;
    //Indien co2emissie onbekend is van Benzine, dan is dit de standaard waarde
  standaardWaardeBenzineUitstoot: number = 182;



  geindexeerdeOndergrens: number = 1690;
  brandstoftypeDropDown = ['Diesel', 'Benzine', 'LPG', 'Electrisch'];

  //aantal maanden dat de auto in gebruik is
  leeftijdsGrenzenAuto = [13, 25, 37, 49, 61];

  //Percentage waarmee de catalogus-waarde wordt vermenigvuldigd volgens de ouderdom van de wagen
  mogelijkeleeftijdPercentages = [1, 0.94, 0.88, 0.82, 0.76, 0.70];

  //Datum van vandaag
  datumVandaag = new Date();

  //tooltip Co2 (momenteel niet opgeslagen in database)
  onderneming: Onderneming;
  vaa: Vaa;

  componentDestoryed$: Subject<boolean> = new Subject();

  //form variabelen
  formBuilder: IFormBuilder;
  vaaFormGroup: IFormGroup<VaaForm>;

  constructor(
    private route: ActivatedRoute,
    formBuilder: FormBuilder,
    private ondernemingService: OndernemingService,
    private vaaService: VaaService,
    public dataService: DataService,
    private cd: ChangeDetectorRef,
  ) { this.formBuilder = formBuilder }

  ngOnInit(): void {
    //Aanmaken van form
    this.vaaFormGroup = this.formBuilder.group<VaaForm>({
      waardeWagen: this.formBuilder.control(0.00, [Validators.required, Validators.min(0)]),
      co2Emissie: this.formBuilder.control(0.00, [Validators.min(0)]),
      brandstofType: this.formBuilder.control(null, [Validators.required]),
      datumInschrijving: this.formBuilder.control(null, [Validators.required]),
    });
    this.loadData();

  }

  loadData() {
    this.onderneming = this.dataService?.getOnderneming();
    this.getVaa(this.onderneming.vaa);
  }



  //Laad de bijhorde Vaa van de onderneming
  getVaa(id: string) {
    if (this.dataService.vaa == undefined) {
      this.vaaService.getVaa(id).pipe(
        takeUntil(this.componentDestoryed$))
        .subscribe(e => {
          this.vaa = e;
          this.cd.markForCheck();
        });

    }
    else {
      this.vaa = this.dataService.vaa;
    }
  }

  //dit wordt uitgevoerd wanneer de knop "bereken wordt ingedrukt"
  onSubmit() {

    var datum = new Date(this.vaaFormGroup.value.datumInschrijving);
    this.berekenKernFormules(datum);
  }

  //Berken het aantal dagen in de geselecteerde maand
  dagenInDeMaand(datum: Date) {
    var jaar = datum.getFullYear();
    var maand = datum.getMonth() + 1;
    return new Date(jaar, maand, 0).getDate()
  }

  //Bereken aantal maand van aanwerving
  berekenAantalDagen(datum: Date) {
    return (this.datumVandaag.getFullYear() - datum.getFullYear()) * 12 + ((this.datumVandaag.getMonth() + 1) - (datum.getMonth() + 1));
  }

  //Berken het leeftijdspercentage van de wagen
  berekenLeeftijdspercentage(aantalMaandInGebruik: number) {
    var check = true;
    var percentage = 0;
    for (var j = 0; j < this.leeftijdsGrenzenAuto.length; j++) {
      //checkt in welke klasse da wagen behoort.
      if (aantalMaandInGebruik < this.leeftijdsGrenzenAuto[j] && check) {
        percentage = this.mogelijkeleeftijdPercentages[j]
        check = false;
      }
    }
    if (percentage == 0) {
      percentage = this.mogelijkeleeftijdPercentages[this.mogelijkeleeftijdPercentages.length - 1];
    }
    return percentage;
  }

  //Berekende de uiteindelijke VAA
  berekenKernFormules(datum: Date) {
    var co2Percentage = 0;

    if (this.vaaFormGroup.value.co2Emissie == 0.00 || this.vaaFormGroup.value.co2Emissie == null) {

      //Indien de co2Emissie van de wagen onbekend is. Wordt er een standaard waarde toegegeven.
      switch (this.vaaFormGroup.value.brandstofType) {
        case 'Benzine':
          co2Percentage = (5.5 +  ((this.standaardWaardeBenzineUitstoot - this.basiscoefBenzine2024)/10))/100;
          //co2Percentage = 0.153;
          break;
        case 'LPG':
          co2Percentage = (5.5 +  ((this.standaardWaardeBenzineUitstoot - this.basiscoefBenzine2024)/10))/100;
          //co2Percentage = 0.153;
          break;
        case 'Diesel':
          co2Percentage = (5.5 +  ((this.standaardWaardeDieselUitstoot - this.basiscoefDiesel2024)/10))/100;
          //co2Percentage = 0.162;
          break;
        case 'Electrisch':
          co2Percentage = 0.04;
          break;
      }
    }
    else {
      var hulp_co2Percentage = 0;

      if (this.vaaFormGroup.value.brandstofType === "Benzine" || this.vaaFormGroup.value.brandstofType === "LPG")
      {
        //Berekening:
        //5.5   Initieel start percentage CO2-Uitstoot
        //+0.1  voor elke extra gram CO2 0.1% erbij optellen, delen door 100 om het effectieve percentage te hebben.
        hulp_co2Percentage = (5.5 + ((this.vaaFormGroup.value.co2Emissie - this.basiscoefBenzine2024)/10))/100;
      }
      else if (this.vaaFormGroup.value.brandstofType === "Diesel")
      {
        hulp_co2Percentage = (5.5 +  ((this.vaaFormGroup.value.co2Emissie - this.basiscoefDiesel2024) /10))/100;
        //co2Percentage = ((this.vaaFormGroup.value.co2Emissie - this.basiscoefDiesel2022) * 0.001) + 0.055;
  
      }
      

      if (hulp_co2Percentage > 0.04 && this.vaaFormGroup.value.brandstofType != 'Electrisch') {

        if (hulp_co2Percentage < 0.18) {
          co2Percentage = hulp_co2Percentage;
        }
        else {
          co2Percentage = 0.18;
        }
      }
      else if (hulp_co2Percentage < 0.04) {
        co2Percentage = 0.04;
      }
      // && this.vaaFormGroup.value.brandstofType === 'Electrisch'
    }






    var dagenMaand = this.dagenInDeMaand(datum);
    var aantalDagen = this.berekenAantalDagen(datum);
    var leeftijdspercentage = this.berekenLeeftijdspercentage(aantalDagen);

 
    //var gekend = ((this.vaaFormGroup.value.waardeWagen * hulpformule * 6 / 7) * 31 / 366) * leeftijdspercentage;
    var gekend = ((this.vaaFormGroup.value.waardeWagen * leeftijdspercentage) * co2Percentage )* 6/7;


    if (this.geindexeerdeOndergrens > gekend) {
      gekend = this.geindexeerdeOndergrens ;
    }



    if (this.vaaFormGroup.value.co2Emissie == 0.00 || this.vaaFormGroup.value.co2Emissie == null) {
      this.result = gekend;

    }
    else {
      this.result = gekend;
    }
    this.calculate = true;
  }

  //Auto unsub
  ngOnDestroy() {
    this.componentDestoryed$.next(true);
    // Now let's also unsubscribe from the subject itself:
    this.componentDestoryed$.unsubscribe();
  }

}
